import Mana from '@/components/Mana/Mana'
import SubNav from '@/components/SubNav/SubNav'
import { RelatedInfoType } from '@/types/page'
import { formatNumber } from '@/utils/helpers'

import styles from './RelatedInfo.module.scss'

type Props = {
  dropdowns?: boolean
  relatedInfo: RelatedInfoType[]
  subpage?: string
  subsubpage?: string
  textRightSuffix?: string
}

const RelatedInfo = ({ dropdowns, relatedInfo, subpage, subsubpage, textRightSuffix }: Props) => {
  return (
    <div className={styles.container}>
      {relatedInfo.map(({ header, items }) => (
        <SubNav
          dropdowns={dropdowns}
          header={header}
          items={items.map(({ colors, count, textLeft, url }) => ({
            colors,
            image: <Mana colors={colors} />,
            padLeft: true,
            selected: url.endsWith(`/${subsubpage || subpage}`),
            textLeft,
            textRight: `${formatNumber(count)}${textRightSuffix ? ` ${textRightSuffix}` : ''}`,
            url,
          }))}
          key={header}
        />
      ))}
    </div>
  )
}

export default RelatedInfo
